import { Outlet } from 'react-router-dom'

/**
 * The persistent simulated-phone shell (shared `.app-frame`, @weapps/design/shell.css) that wraps every
 * campaign surface, so on desktop the campaign renders as the same bezelled phone the preview and the app
 * use — and the bezel stays constant while Landing → Working → error content swaps inside it. `id="app-frame"`
 * mirrors grow so any in-frame fixed overlay is contained by the phone rather than the desk.
 */
export function Frame() {
  return (
    <div id="app-frame" className="app-frame relative mx-auto flex max-w-md flex-col" style={{ background: 'var(--scr)' }}>
      <Outlet />
    </div>
  )
}
